export default {
  offeringDocuments: [],
};
